/** PURE_IMPORTS_START .._.._Observable,.._.._observable_from PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { from as staticFrom } from '../../observable/from';
Observable.from = staticFrom;
//# sourceMappingURL=from.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/observable/from.js
// module id = 623
// module chunks = 0